//配置axios

import axios from 'axios'
import { Toast } from 'vant';
import store from '../vuex/store.js'
import base from './base.js';

// 请求超时时间
axios.defaults.timeout = 1000 * 10;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

// 设置公共url
axios.defaults.baseURL = base.baseUrl;//'http://192.168.1.204:9805'
function checkToken(token){
  //let Base64 = require("js-base64").Base64;
  //let tk=token;//"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb21wYW55SWQiOiIwMjAxYjRhYjUzMGI5ZmZlMmZlNzIxNTJmZTRhYjE5NSIsInN0YWZmTmFtZSI6Ium7hOiKsyIsInN0YWZmSWQiOiJkZjAwYjlhYjZlYmMzYWIwMTc1M2Y4ZTAwYTRiOTQwOSIsImlhdCI6MTY3MzUxNTA4MSwiZXhwIjoxNjczNTIyMjgxLCJuYmYiOjE2NzM1MTUwODF9.owYBDjvlielj1Ma_QakPlErPHky248RcFLJFrFdfWR8";
  //let tangdaye=JSON.parse(Base64.decode(tk.split('.')[1]));
  //let endTime=new Date(tangdaye.exp*1000);
  let oldDate=store.state.stateObject.tokenRefreshTime;
  //  if((endTime-new Date()<3600000)&&endTime>new Date()){
  //   commonObj.checkTokenRefresh();
  //  }else if(endTime<new Date()){
  //   commonObj.logout("登陆已失效");
  //  }
  //3600000-86400000
  if((new Date()-oldDate)>3600000&&(new Date()-oldDate)<86400000){
    commonObj.checkTokenRefresh();
   }else if((new Date()-oldDate)>86400000){
    commonObj.logout("登陆已失效");
   }
 // console.log(tangdaye)
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {

  // config.headers["Accept"] = "application/json;charset=UTF-8";
  // if (store.state.stateObject.userInfo.token) {
  // config.headers['Access-Control-Allow-Headers'] = "accept,authorization,token";
  config.headers["port"] = "1";
  if (store.state.stateObject.userInfo && store.state.stateObject.userInfo.token) {
    
    config.headers["token"] = store.state.stateObject.userInfo.token;
  }
  let projectId = localStorage.getItem("headerProjectId");
  if (projectId) {
    config.headers["projectId"] = projectId;
  }
  let headerHisId = localStorage.getItem("headerHisId");
  if (headerHisId) {
    config.headers["hisId"] = headerHisId;
  }
  // }
  if(!store.state.stateObject.getTokening){
    checkToken(config.headers["token"]);
  }
  let userinfo = commonObj.getUserInfo();
  config.headers["companyId"] = userinfo.companyId;
  //config.url="";
  // console.log(config);


//   while( i <= 5) {
//     document.write(i+", ");
//     i++;
//     console.log(i)
// }




  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // console.log(error);
  // 对请求错误做些什么
  return Promise.reject(error);
});


// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // console.log(response);
  if(response.data&&response.data.code&&(response.data.code=="020001"||response.data.code=="020002"||response.data.code=="020003")&&!store.state.stateObject.alertOut){
    //Toast(response.data.msg);
    store.state.stateObject.alertOut=true;
    commonObj.logout(response.data.msg);
  }else{
    return response.data;
  }
  // if (response.data.code == "000000") {
  //   console.log(response.data);
  //   return response.data;
  // } 
  // 对响应数据做点什么
  
}, function (error) {
  console.log(error.message);
  var title = ""
  if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
    Toast("网络超时");        // reject这个错误信息
    title="网络超时";
  } else {
  if (error.code == "ECONNABORTED" || error.message.indexOf("Network Error") > -1) {
    Toast("网络异常！")
    title = "网络异常！"
  } else {
    if(error.config&&error.config.url&&error.config.url.indexOf("settlement/settlement/count")!=-1){
        // reject这个错误信息
        //title="网络超时";
      }else{
        if(error.response&&error.response.data&&error.response.data.message){
          Toast(error.response.data.message);
          title=error.response.data.message;
        }else{
          Toast("服务异常！");
          title="网络异常！";
        }
      }
  }
  }
  // if(error.message!="Cannot read properties of undefined (reading 'cancelToken')"){
  //   commonLogan.loganLog(title+error.message+ "postParm:"+JSON.stringify(error.config),1);
  // }
  //commonLogan.loganLog(title+error.message+ "postParm:"+JSON.stringify(error.config),1);

  try {
  SXApi.call(
    function (suc) {
    },
    null,
    "FunctionPlugin",
    "postError",
    { "message": error.message + "|||(" + title + ")|||(" + error.code + ")" }
  );
} catch (error) {}
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/request/$http.js